import styled from 'styled-components';

export const LargeNumber = styled.div<{ $fontColor: string }>`
	color: ${({ $fontColor }) => $fontColor};
	font-variant-numeric: lining-nums tabular-nums;
	text-overflow: ellipsis;

	font-family: Inter;
	font-size: 2rem;
	font-style: normal;
	font-weight: 600;
	line-height: 2.5rem;
`;

export const NumberText = styled.div<{ $fontColor: string; $fontWeight?: number }>`
	display: flex;
	color: var(--Colour-darks-0, #4f616c);
	font-variant-numeric: lining-nums tabular-nums;

	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: ${({ $fontWeight }) => $fontWeight || 600};
	line-height: 1.25rem;
`;

export const NumberContainer = styled.div`
	/* width: 32rem; */
	flex-wrap: nowrap;
	padding-right: 1rem;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	border-right: 1px solid ${({ theme }) => theme.color.greys[200]};
	&:last-child {
		border-right: none;
	}
`;

export const NumberTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;
